"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YTVideo = exports.VideoWrapper = void 0;
exports.default = Video;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactYoutube = _interopRequireDefault(require("react-youtube"));
// NOTE: this is more of a YouTubeVideo component, but we're using it for all video embeds
// we really should have a Video component that can handle multiple video sources, so we
// don't have to reinvent the wheel for each video source. This is a good start though.
//
// we should also support videos of other aspect ratios, and not just 16:9

const VideoWrapper = exports.VideoWrapper = _styledComponents.default.div`
  position: relative;
  display: block;
  height: 0;
  flex-shrink: 0;
  padding-bottom: 56.25%;
  width: 100%;
`;
const YTVideo = exports.YTVideo = _styledComponents.default.div.attrs({
  as: _reactYoutube.default
})`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;

  iframe {
    height: 100%;
    width: 100%;
  }
`;
function Video({
  onReady,
  videoId,
  autoplay = true
}) {
  return /*#__PURE__*/_react.default.createElement(VideoWrapper, null, /*#__PURE__*/_react.default.createElement(YTVideo, {
    opts: {
      width: 1120,
      playerVars: {
        autoplay: autoplay ? 1 : 0,
        vq: 'hd1080',
        rel: 0,
        color: 'white',
        controls: 1
      }
    },
    videoId: videoId,
    onReady: onReady
  }));
}
Video.propTypes = {
  autoplay: _propTypes.default.bool,
  onReady: _propTypes.default.func,
  videoId: _propTypes.default.string.isRequired
};